import React from "react";
import { Typography } from "@genie-ui/react";
import WarningIcon from "@mui/icons-material/Warning";
import { Constants } from "@constants";

const ErrorMessage = () => {
  return (
    <>
      <WarningIcon />
      <Typography variant="body2">
        {Constants.SEARCH.ERROR_MESSAGE_1}
      </Typography>
      <Typography variant="body1">
        {Constants.SEARCH.ERROR_MESSAGE_2}
      </Typography>
    </>
  );
};

export default ErrorMessage;
